import { useState } from 'react';
import projects from '../../../data/projects';

const RARITY_DOT = {
  legendary: 'bg-os-yellow',
  epic: 'bg-purple-400',
  rare: 'bg-os-accent',
};

const RARITY_LABEL = {
  legendary: 'Legendary',
  epic: 'Epic',
  rare: 'Rare',
};

const RARITY_TEXT = {
  legendary: 'text-os-yellow',
  epic: 'text-purple-400',
  rare: 'text-os-accent',
};

export default function ProjectsApp() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selected = projects[selectedIndex];

  return (
    <div className="flex h-full font-os text-os-text">
      <div className="w-56 shrink-0 border-r border-white/10 bg-os-surface2/60 overflow-y-auto">
        <div className="px-3 pt-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-os-textdim">
          Projects
        </div>
        <ul>
          {projects.map((project, index) => {
            const isSelected = index === selectedIndex;
            return (
              <li key={project.title}>
                <button
                  type="button"
                  onClick={() => setSelectedIndex(index)}
                  className={`w-full flex items-center gap-2 px-3 py-2 text-left text-sm transition-colors ${
                    isSelected
                      ? 'bg-os-accent text-white'
                      : 'text-os-text hover:bg-os-surface3/60'
                  }`}
                >
                  <span
                    className={`h-2 w-2 shrink-0 rounded-full ${RARITY_DOT[project.rarity] || 'bg-os-textdim'}`}
                  />
                  <span className="truncate">{project.title}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="flex-1 min-w-0 overflow-y-auto bg-os-surface">
        {selected && (
          <div className="p-6 max-w-2xl">
            <div className="flex items-center gap-2 mb-1">
              <span
                className={`h-2.5 w-2.5 rounded-full ${RARITY_DOT[selected.rarity] || 'bg-os-textdim'}`}
              />
              <span
                className={`text-xs font-semibold uppercase tracking-wider ${RARITY_TEXT[selected.rarity] || 'text-os-textdim'}`}
              >
                {RARITY_LABEL[selected.rarity] || selected.rarity}
              </span>
            </div>

            <h1 className="text-2xl font-semibold text-os-text mb-3">
              {selected.title}
            </h1>

            <p className="text-sm leading-relaxed text-os-textdim mb-5">
              {selected.description}
            </p>

            {selected.tags && selected.tags.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-6">
                {selected.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-full text-xs font-medium bg-os-surface3/70 text-os-text border border-white/10"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            )}

            {selected.link && (
              <a
                href={selected.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-os-accent text-white text-sm font-medium hover:bg-os-accent/90 transition-colors shadow-[0_4px_20px_rgba(10,132,255,0.3)]"
              >
                Open Project
                <span aria-hidden="true">↗</span>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
